// extracted by mini-css-extract-plugin
module.exports = {"image":"cI","image-placeholder":"cJ","imagePlaceholder":"cJ"};